import React, {Component} from 'react'
import {ApolloProvider, Query, Mutation} from 'react-apollo'
import {Row, Col, Card, Modal, ModalBody, ModalFooter, ModalHeader, Button, Input} from 'reactstrap'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import Scheduler, {SchedulerData, ViewTypes, DATE_FORMAT} from '../../components/Scheduler'
import '../../components/Scheduler/css/style.css'
import moment from 'moment'

import CreateSchedule from '../../components/Scheduler/CreateSchedule'
import EditSchedule from '../../components/Scheduler/EditSchedule'
import withDndContext from '../../components/Scheduler/withDnDContext'
import QUERY from '../../../queries/server/active_user_schedules'
import CS_CREATE_SCHEDULE_QUERY from '../../../queries/client_side/create_schedule'
import CS_EDIT_SCHEDULE_QUERY from '../../../queries/client_side/edit_schedule'
import CS_EDIT_CREATE_SCHEDULE_MUTATION from '../../../queries/client_side/mutations/edit_create_schedule_mutation'
import CS_EDIT_SCHEDULE_MUTATION from '../../../queries/client_side/mutations/edit_schedule_mutation'
import CS_SET_SCHEDULE_MUTATION from '../../../queries/client_side/mutations/set_schedule_mutation'
import SERVER_CREATE_SCHEDULE_MUTATION from '../../../queries/server/mutations/create_schedule_mutation'
import {toast} from "react-toastify";
import AUSelectGenerator from "../auto_updaters/Select";
import ExportModal from "../../components/Scheduler/ExportModal";

moment().utcOffset(0)

const OfficeSelect = AUSelectGenerator('offices', 'id description', 'id', ['description'])

class Schedule extends Component {

    state = {
        data: [],
        createEventOpen: false,
        editEventOpen: false,

    }

    static getDerivedStateFromProps(props, state) {
        return {...state, ...props}
    }

    onViewChange = (data, view) => {
        data.setViewType(view.viewType, view.showAgenda, view.isEventPerspective)
        console.log('data', data, this.state)
        data.setEvents(this.state.data.events)
        this.setState({data})
    }

    prevClick = (data) => {
        data.prev();
        data.setEvents(this.state.data.events);
        this.setState({data})
    }

    nextClick = (data) => {
        data.next();
        data.setEvents(this.state.data.events);
        this.setState({data})
    }

    newEvent = (data, slotId, slotName, start, end, type, item) => {
        this.setState({data})
        this.toggleCreate()
    }

    updateEventStart = (data, event, newStart) => {
        data.updateEventStart(event, newStart);
        this.setState({data})
    }

    updateEventEnd = (data, event, newEnd) => {
        data.updateEventEnd(event, newEnd);
        this.setState({data})
    }

    moveEvent = (data, event, slotId, slotName, start, end) => {
        data.moveEvent(event, slotId, slotName, start, end);
        this.setState({data})
    }

    toggleCreate = () => {
        this.setState({createEventOpen: !this.state.createEventOpen})
    }

    toggleEdit = () => {
        this.setState({editEventOpen: !this.state.editEventOpen})
    }

    onScrollRight = (data, schedulerContent, maxScrollLeft) => {
        console.log(maxScrollLeft)
        data.next();
        data.setEvents(this.state.data.events);
        this.setState({data})
        schedulerContent.scrollLeft = 1;
    }

    onScrollLeft = (data, schedulerContent, maxScrollLeft) => {
        data.prev();
        data.setEvents(this.state.data.events);
        this.setState({data})
        schedulerContent.scrollLeft = maxScrollLeft - 1;
    }


    render() {
        const {data, createEventOpen, editEventOpen} = this.state

        return (
            <Mutation mutation={CS_SET_SCHEDULE_MUTATION}>
                {(setSchedule) => {
                    return (
                        <Mutation mutation={CS_EDIT_CREATE_SCHEDULE_MUTATION}>
                            {(go) => {
                                return (
                                    <Mutation
                                        mutation={SERVER_CREATE_SCHEDULE_MUTATION}
                                        update={(cache, {data: {upsert_user_schedule}}) => {

                                            const {office_id, line_manager_user_id} = this.props

                                            console.log('upsert_user_schedule', upsert_user_schedule)

                                            const {active_users} = cache.readQuery({
                                                query: QUERY,
                                                variables: {office_id, line_manager_user_id}
                                            });
                                            const d = cache.readQuery({
                                                query: QUERY,
                                                variables: {office_id, line_manager_user_id}
                                            })

                                            console.log('active_users', d)

                                            const newActiveUsers = active_users.map(user => {

                                                const scheduleRemovedIndex =
                                                    user.schedules.findIndex(({id}) => {
                                                        return (id === upsert_user_schedule.id &&
                                                            user.user_id !== upsert_user_schedule.user_id) ||

                                                            (id === upsert_user_schedule.id &&
                                                                !upsert_user_schedule.active)
                                                    })

                                                if (scheduleRemovedIndex !== -1) {
                                                    return {
                                                        ...user,
                                                        schedules: [
                                                            ...user.schedules.slice(0, scheduleRemovedIndex),
                                                            ...user.schedules.slice(scheduleRemovedIndex + 1)
                                                        ]
                                                    }
                                                }

                                                if (user.user_id === upsert_user_schedule.user_id) {
                                                    const recordIndex = user.schedules.findIndex(({id}) => id === upsert_user_schedule.id)

                                                    if (recordIndex === -1) {
                                                        return {
                                                            ...user,
                                                            schedules: [
                                                                ...user.schedules,
                                                                {...upsert_user_schedule}
                                                            ]
                                                        }
                                                    }

                                                    return {
                                                        ...user,
                                                        schedules: [
                                                            ...user.schedules.slice(0, recordIndex),
                                                            {...upsert_user_schedule},
                                                            ...user.schedules.slice(recordIndex + 1),
                                                        ]
                                                    }

                                                }

                                                return user
                                            })

                                            console.log('newActiveUsers', newActiveUsers)

                                            cache.writeQuery({
                                                query: QUERY,
                                                variables: {office_id, line_manager_user_id},
                                                data: {active_users: newActiveUsers},
                                            });
                                        }}
                                    >
                                        {(createSchedule, result) => {
                                            return (
                                                <div>

                                                    <Scheduler
                                                        rightCustomHeader={this.props.rightCustomHeader}
                                                        schedulerData={data.schedulerData}
                                                        onScrollRight={this.onScrollRight}
                                                        onScrollLeft={this.onScrollLeft}
                                                        prevClick={this.prevClick}
                                                        nextClick={this.nextClick}
                                                        onSelectDate={console.log}
                                                        newEvent={(data, slotId, slotName, start, end, type, item) => {
                                                            go({
                                                                variables: {
                                                                    data: {
                                                                        start_date: start,
                                                                        end_date: end,
                                                                        user_id: slotId
                                                                    }
                                                                }
                                                            })
                                                            this.newEvent(data, slotId, slotName, start, end, type, item)
                                                        }}
                                                        updateEventStart={(data, event, newStart) => {
                                                            const {id, end_date, user_schedule_type_id, user_id, project_activity_budget_id} = event.item

                                                            createSchedule({
                                                                variables: {
                                                                    data: {
                                                                        id,
                                                                        start_date: newStart,
                                                                        end_date,
                                                                        user_schedule_type_id,
                                                                        user_id,
                                                                        project_activity_budget_id,
                                                                        created_by_user_id: this.props.user_id
                                                                    }
                                                                }
                                                            })
                                                                .then(res => {
                                                                    toast.success('Successfully Saved!', {autoClose: 2000})
                                                                }).catch(e => toast(e.message, {autoClose: false}))
                                                            this.updateEventStart(data, event, newStart)
                                                        }}
                                                        updateEventEnd={(data, event, newEnd) => {
                                                            const {id, start_date, user_schedule_type_id, user_id, project_activity_budget_id} = event.item
                                                            createSchedule({
                                                                variables: {
                                                                    data: {
                                                                        id,
                                                                        start_date,
                                                                        end_date: newEnd,
                                                                        user_schedule_type_id,
                                                                        user_id,
                                                                        project_activity_budget_id,
                                                                        created_by_user_id: this.props.user_id
                                                                    }
                                                                }
                                                            })
                                                                .then(res => {
                                                                    toast.success('Successfully Saved!', {autoClose: 2000})
                                                                }).catch(e => toast(e.message, {autoClose: false}))
                                                            this.updateEventEnd(data, event, newEnd)
                                                        }}
                                                        moveEvent={(data, event, slotId, slotName, start, end) => {
                                                            const {id, start_date, user_schedule_type_id, user_id, project_activity_budget_id} = event.item
                                                            createSchedule({
                                                                variables: {
                                                                    data: {
                                                                        id,
                                                                        start_date: start,
                                                                        end_date: end,
                                                                        user_schedule_type_id,
                                                                        user_id: slotId,
                                                                        project_activity_budget_id,
                                                                        created_by_user_id: this.props.user_id
                                                                    }
                                                                }
                                                            })
                                                                .then(res => {
                                                                    toast.success('Successfully Saved!', {autoClose: 2000})
                                                                }).catch(e => toast(e.message, {autoClose: false}))
                                                            this.moveEvent(data, event, slotId, slotName, start, end)
                                                        }}
                                                        onViewChange={this.onViewChange}
                                                        eventItemClick={(data, event) => {
                                                            if(event.hasOwnProperty('annualLeave') && event.annualLeave){
                                                                //do nothing for the moment
                                                            }
                                                            else{
                                                                setSchedule({variables: {data: event.item}})
                                                                this.toggleEdit()
                                                            }
                                                        }}
                                                        eventItemPopoverTemplateResolver={(schedulerData, eventItem, title, start, end, statusColor) => {
                                                            const {item} = eventItem

                                                            if(eventItem.hasOwnProperty('annualLeave') && eventItem.annualLeave){
                                                                return (
                                                                    <React.Fragment>
                                                                        <h3>{title}</h3>
                                                                        <h5>{start.format("DD/MM/YY")} - {(item.start_of_day) ? `Start of Day` : `Afternoon`} to {end.format("DD/MM/YY")} - {(item.end_of_day) ? `End of Day` : `Afternoon`}</h5>
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                            else{
                                                                return (
                                                                    <React.Fragment>
                                                                        <h3>{title}</h3>
                                                                        <h5>{start.format("DD/MM/YY HH:mm")} - {end.format("DD/MM/YY HH:mm")}</h5>
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                            
                                                        }}
                                                    />

                                                    <Modal isOpen={createEventOpen} toggle={this.toggleCreate}>
                                                        <ModalBody>
                                                            <Query query={CS_CREATE_SCHEDULE_QUERY}>
                                                                {({data}) => {
                                                                    return (


                                                                        <CreateSchedule
                                                                            onSubmit={({formData}) => createSchedule({
                                                                                variables: {
                                                                                    data: {
                                                                                        ...formData,
                                                                                        created_by_user_id: this.props.user_id
                                                                                    }
                                                                                }
                                                                            }).then(res => {
                                                                                toast.success('Successfully Saved!', {autoClose: 2000})
                                                                                this.toggleCreate()
                                                                            }).catch(e => toast(e.message, {autoClose: false}))}
                                                                            formData={data.createSchedule}
                                                                            onChange={({formData}) => go({variables: {data: formData}})}
                                                                        >
                                                                            <ModalFooter>
                                                                                <Button
                                                                                    size="sm"
                                                                                    color="secondary"
                                                                                    onClick={this.toggleCreate}>
                                                                                    <FontAwesomeIcon
                                                                                        color="#fff"
                                                                                        icon="times"/>{' '}
                                                                                    Cancel
                                                                                </Button>
                                                                                <Button
                                                                                    size="sm"
                                                                                    color="success"
                                                                                    type="submit"
                                                                                    disabled={result.loading}>
                                                                                    <FontAwesomeIcon
                                                                                        color="#fff"
                                                                                        icon="save"/>{' '}
                                                                                    {(result.loading) ? 'Saving...' : 'Save'}
                                                                                </Button>
                                                                            </ModalFooter>
                                                                        </CreateSchedule>


                                                                    )
                                                                }}
                                                            </Query>

                                                        </ModalBody>
                                                    </Modal>

                                                    <Modal isOpen={editEventOpen} toggle={this.toggleEdit}>
                                                        <ModalBody>
                                                            <Query query={CS_EDIT_SCHEDULE_QUERY}>
                                                                {({data}) => {
                                                                    return (
                                                                        <Mutation mutation={CS_EDIT_SCHEDULE_MUTATION}>
                                                                            {(editSchedule) => {
                                                                                return (
                                                                                    <EditSchedule
                                                                                        onSubmit={({formData}) => createSchedule({
                                                                                            variables: {
                                                                                                data: {
                                                                                                    ...formData,
                                                                                                    created_by_user_id: this.props.user_id
                                                                                                }
                                                                                            }
                                                                                        }).then(res => {
                                                                                            toast.success('Successfully Saved!', {autoClose: 2000})
                                                                                            this.toggleEdit()
                                                                                        }).catch(e => toast(e.message, {autoClose: false}))}
                                                                                        formData={data.editSchedule}
                                                                                        onChange={({formData}) => editSchedule({variables: {data: formData}})}
                                                                                    >
                                                                                        <ModalFooter>
                                                                                            <Button
                                                                                                size="sm"
                                                                                                color="secondary"
                                                                                                onClick={this.toggleEdit}>
                                                                                                <FontAwesomeIcon
                                                                                                    color="#fff"
                                                                                                    icon="times"/>{' '}
                                                                                                Cancel
                                                                                            </Button>
                                                                                            <Button
                                                                                                size="sm"
                                                                                                color="success"
                                                                                                type="submit"
                                                                                                disabled={result.loading}>
                                                                                                <FontAwesomeIcon
                                                                                                    color="#fff"
                                                                                                    icon="save"/>{' '}
                                                                                                {(result.loading) ? 'Saving...' : 'Save'}
                                                                                                </Button>
                                                                                        </ModalFooter>
                                                                                    </EditSchedule>
                                                                                )
                                                                            }}
                                                                        </Mutation>

                                                                    )

                                                                }}
                                                            </Query>

                                                        </ModalBody>
                                                    </Modal>
                                                </div>
                                            )
                                        }}

                                    </Mutation>
                                )
                            }}
                        </Mutation>
                    )
                }
                }
            </Mutation>


        )

    }
}


class StaffResource extends Component {


    static getDerivedStateFromProps(props, state) {
        return {...state}
    }

    constructor(props) {
        super(props)

        let schedulerData = new SchedulerData(new moment().startOf('week').format(DATE_FORMAT), ViewTypes.Week, false, false, {
            weekMaxEvents: 100,
            dayMaxEvents: 100,
            monthMaxEvents: 100,
            yearMaxEvents: 100,
            quarterMaxEvents: 100,
            customMaxEvents: 100
        });
        schedulerData.setLocaleMoment(moment);
        //schedulerData.config.schedulerWidth = '100%'

        this.state = {
            schedulerData,
            office_id: '',
            line_manager_user_id: '',
            exportModalOpen: false
        }
    }

    getScheduleData = (users) => {
        const schedulerData = this.state.schedulerData
        const resources = users.map(({user_id, full_name}) => ({id: user_id, name: full_name}))
        let events = []
        users.forEach(({user_id, schedules, annual_leave}) => {
            const evts = schedules.map((schedule) => {
                const {id, start_date, end_date, project_activity_budget} = schedule
                return Object.assign({
                        id,
                        start: start_date,
                        end: end_date,
                        resourceId: user_id,
                        title: project_activity_budget ?
                            `${project_activity_budget.project_id} ${project_activity_budget.project.name}` : '',
                        item: schedule,
                    },
                    //(user_project_activities && user_project_activities.length) ? ((user_project_activities[0].project_id === 'W1001') ? {bgColor: '#85d79f'} : {}) : {}
                    )
            })
            events = events.concat(evts)

            const annualLeave = annual_leave.reduce((carry, al) => {
                const {id, start_date, start_of_day, end_date, end_of_day, status_id} = al
                const startDate = moment.utc(start_date).format('YYYY-MM-DD')
                const endDate = moment.utc(end_date).format('YYYY-MM-DD')
                if(status_id === 1 || status_id === 2){
                    carry.push({
                        id,
                        start: (start_of_day) ? 
                            moment.utc(`${startDate} 00:00:00`).format('YYYY-MM-DD HH:mm:ss') : 
                            moment.utc(`${startDate} 12:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        end: (end_of_day) ? 
                            moment.utc(`${endDate} 23:59:59`).format('YYYY-MM-DD HH:mm:ss') : 
                            moment.utc(`${endDate} 12:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        resourceId: user_id,
                        title: `Annual Leave`,
                        item: al,
                        annualLeave: true,
                        bgColor: (status_id === 2) ? '#85d79f' : '#ceefd8',
                        movable: false,
                        resizable: false
                    })
                }
                return carry
            }, [])

            events = events.concat(annualLeave)
        })

        console.log('EVENTS', events)

        events = events.sort((a, b) => moment.utc(a.start).valueOf() - moment.utc(b.start).valueOf())

        schedulerData.setResources(resources)
        schedulerData.setEvents(events)

        return {schedulerData, events, resources}
    }

    toggleExportModal = () => {
        this.setState({exportModalOpen: !this.state.exportModalOpen})
    }

    handleExport = (url) => {
        window.open(url, '_self');
    }

    onClose = () => {
        this.setState({exportModalOpen: false})
    }

    render() {

        const {office_id, line_manager_user_id, exportModalOpen} = this.state

        let rightCustomHeader = (
            <Button
                size="sm"
                color="primary"
                onClick={this.toggleExportModal}
            >
                <FontAwesomeIcon
                    color="#fff"
                    icon="file-export"/>{' '}
                Export
            </Button>
        );

        return (

            <div className="mt-4">
                <Row>
                    <Col>
                        <Input
                            size="sm"
                            type="select"
                            value={line_manager_user_id}
                            onChange={evt => this.setState({line_manager_user_id: evt.target.value})}
                        >
                            <option value={this.props.user_id}>My Team</option>
                            <option value="">Everyone</option>
                        </Input>
                    </Col>

                    <Col>
                        <OfficeSelect
                            size="sm"
                            defaultLabel="All Offices"
                            value={office_id}
                            onChange={(office_id) => this.setState({office_id})}
                        />
                    </Col>
                </Row>
                <Query fetchPolicy="network-only" query={QUERY} variables={{office_id, line_manager_user_id}}>
                    {({loading, error, data}) => {

                        if (loading) return <h1>Loading...</h1>
                        if (error) return <h1>Oops there was an error</h1>

                        //console.log('schedule data', data, this.getScheduleData(data.active_users))

                        return <Schedule
                            user_id={this.props.user_id}
                            office_id={office_id}
                            line_manager_user_id={line_manager_user_id}
                            data={this.getScheduleData(data.active_users)}
                            rightCustomHeader={rightCustomHeader}
                        />
                    }}
                </Query>
                <ExportModal
                    isOpen={exportModalOpen}
                    toggle={this.toggleExportModal}
                    onExported={this.handleExport}
                    onClose={this.onClose}
                />
                <ToastContainer/>
            </div>

        )
    }
}

export default withDndContext(StaffResource)